// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/redebit-payment-status-schema',
  type: 'object',
  required: [],
  nullable: true,
  properties: {
    status: {
      type: 'string',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
